import React from "react";
import { Link } from "react-router-dom";
import { Construction, ArrowLeft } from "lucide-react";

interface Props {
  title: string;
  description?: string;
}

const PlaceholderPage: React.FC<Props> = ({ title, description }) => (
  <div className="min-h-screen bg-bg-page pt-24 flex items-center justify-center">
    <div className="text-center max-w-md mx-auto px-4">
      <Construction size={56} className="text-brand-gold mx-auto mb-5 opacity-70" />
      <h1 className="text-2xl font-bold text-text-primary mb-3">{title}</h1>
      <p className="text-text-muted mb-6 leading-relaxed">
        {description ||
          "Bu sayfa yakında hazır olacak. Çalışmalarımız devam etmektedir."}
      </p>
      <Link
        to="/"
        className="inline-flex items-center gap-2 text-brand-bordo font-semibold hover:gap-3 transition-all text-sm"
      >
        <ArrowLeft size={15} /> Ana Sayfaya Dön
      </Link>
    </div>
  </div>
);

export default PlaceholderPage;
